import { motion } from 'framer-motion'
import React, { Fragment, FunctionComponent } from 'react'
import { ReactElement } from 'react'

type Props = {
  data: {
    title: string
    subtitle?: string
  }
  children: ReactElement | ReactElement[]
}

const HeroWithCustomComponent: FunctionComponent<Props> = (props) => {
  return (
    <Fragment>
      <motion.div initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'tween', duration: 1 }} className="container">
        <h2 className="lg:text-[50px] mt-5 md:mt-0 md:text-[35px] text-white font-lato text-[30px] font-bold leading-[1.2em] mb-6 lg:w-2/3 mx-auto">{props.data.title}</h2>
        {props.data.subtitle && <p className="text-[#c2c1ca] lg:w-2/3 mx-auto">{props.data.subtitle}</p>}
        <div className="mt-4">{props.children}</div>
      </motion.div>
    </Fragment>
  )
}

export default HeroWithCustomComponent
